export enum GridClass {
  SCROLLABLE_CONTENT = 'scrollable-content',
  DENSE_MODE = 'dense-mode',
}
